'use client';
import { useEffect, useRef, ReactNode } from 'react';

interface PageTransitionProps {
  children: ReactNode;
  className?: string;
}

export default function PageTransition({ children, className = '' }: PageTransitionProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.classList.add('page-transition-enter');
    const timer = setTimeout(() => {
      el.classList.add('page-transition-enter-active');
    }, 10);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div ref={ref} className={`page-transition-base ${className}`}>
      {children}
    </div>
  );
}
